import { plural } from 'pluralize';
import apiApp from '~/config/apiApp';

import errorHandler from '~/shared/errors/handler';
import dictionaryEntity from '~/shared/providers/utils/dictionaryEntity';

class SharedFormDataAppRepository {
  constructor() {
    this.apiApp = apiApp;
  }

  async execute({ entityName = '', parser = null }) {
    try {
      const { data } = await this.apiApp
        .get(`/${plural(entityName).replace('_', '-')}/form-data`)
        .then(res => res.data);

      if (parser) return parser([{ ...data }])[0];

      return data;
    } catch (error) {
      const errors = errorHandler({
        error,
        title: `Error ao buscar dados para cria um ${
          dictionaryEntity({
            entityName,
          }) || 'Dados'
        }`,
        local: 'SharedFormDataAppRepository',
      });

      throw errors;
    }
  }
}

export default SharedFormDataAppRepository;
